import actionTypes from '../constants/action-types';

const unblock = () => ({
  type: actionTypes.UNBLOCK,
});

export default unblock;
